export const injectScriptCampaigns = new Map();
injectScriptCampaigns.set("92", {});
